'use client';
import React from 'react';
import styled from '@benzinga/themetron';

import { Layout, SectionTitle } from '@benzinga/core-ui';
import { EntityAttribute, Profile, ProfileSection as ProfileSectionInterface } from '@benzinga/content-manager';
import { ProfileHeader } from './ProfileHeader';
import { ProfileSection } from './ProfileSection';
import { EntityAttributeCard } from '@benzinga/entity-ui';
import { Popup, MoneyBlocks } from '@benzinga/money';
import { isMobile } from '@benzinga/device-utils';

import { Tabs } from 'antd';
const { TabPane } = Tabs;

export interface ProfileLayoutProps {
  profile: Profile;
  currentTab?: string;
}

const ProfileMain: React.FC<ProfileLayoutProps> = ({ profile }) => {
  const [currentTab, setCurrentTab] = React.useState(profile.sections?.[0]?.title);

  const handleTabChange = React.useCallback(tab => {
    setCurrentTab(tab);
  }, []);

  if (profile.sections?.length === 1) {
    const section = profile.sections[0];
    return (
      <>
        {section.title && (
          <SectionTitle bordered level={2}>
            {section.title}
          </SectionTitle>
        )}
        <ProfileSection entity={profile.entity} section={section} />
      </>
    );
  } else if (profile.sections?.length > 1) {
    return (
      <Tabs activeKey={currentTab} className="profile-tabs" onChange={handleTabChange}>
        {profile.sections.map((section: ProfileSectionInterface) => (
          <TabPane key={section.title} tab={section.title}>
            <ProfileSection entity={profile.entity} section={section} />
          </TabPane>
        ))}
      </Tabs>
    );
  }
  return null;
};

export const ProfileLayout: React.FC<ProfileLayoutProps> = ({ profile }) => {
  return (
    <ProfileLayoutWrapper>
      <Layout
        breadcrumbs={profile.breadcrumbs}
        className={profile.layout}
        layoutFooter={
          isMobile() && (
            <div className="space-y-4">
              {Array.isArray(profile?.info) &&
                profile.info.map((attr: EntityAttribute) => <EntityAttributeCard attribute={attr} key={attr.label} />)}
            </div>
          )
        }
        layoutLeftSidebar={
          <div className="space-y-4">
            <ProfileHeader profile={profile} />
            {profile.info && profile.info.length > 0 && !isMobile() && (
              <>
                {profile.info.map((attr: EntityAttribute) => (
                  <EntityAttributeCard attribute={attr} key={attr.label} />
                ))}
              </>
            )}
          </div>
        }
        layoutMain={<ProfileMain profile={profile} />}
        // layoutSidebar={(
        //   <ProfileCallToAction profile={profile} />
        // )}
        layoutSidebar={
          profile?.sidebar?.blocks &&
          profile?.sidebar?.blocks?.length > 0 && <MoneyBlocks blocks={profile.sidebar?.blocks} />
        }
        notification={profile.notification}
        sidebarSettings={{ offsetTop: 150, visibleOnMobile: true }}
        title={profile.title}
      />
      {profile?.unmonetized_interstitial && <Popup interstitial={true} popup={profile.unmonetized_interstitial} />}
    </ProfileLayoutWrapper>
  );
};

const ProfileLayoutWrapper = styled.div`
  .section-title {
    width: 100%;
    margin-bottom: 1rem;
  }
  .profile-tabs {
    width: 100%;
  }
  .layout-main {
    display: block;
    width: 100%;
  }
  /* .layout-header {
    background-color: white;
    border-bottom: solid 1px #ddd;
  } */
  @media (max-width: 800px) {
    .layout-sidebar {
      width: 100%;
    }
    .ticker-card-container {
      max-width: 100% !important;
    }
    .layout-main {
      padding: 0.25rem;
    }
  }

  .layout-left-sidebar {
    max-width: 350px;
    min-width: 320px;
    width: 100%;
    padding-right: 1rem;
    @media (max-width: 1120px) {
      display: block;
      max-width: 300px;
      /* width: 300px; */
    }
    @media (max-width: 800px) {
      width: 100%;
    }
  }
  h2,
  h3 {
    &.core-block {
      margin-top: 1rem;
    }
  }
  h2 {
    &.core-block {
      font-size: 24px;
      font-weight: 600;
      margin-bottom: 0.25rem;
      text-transform: uppercase;
      width: 100%;
    }
  }
  .etfs {
    display: block;
    .layout-left-sidebar {
      display: block;
      .entity-attr {
        &.textarea {
          padding: 8px 16px;
          h5 {
            border: none;
          }
        }
        &.text {
          display: flex;
          justify-content: space-between;
          font-family: Manrope;
          line-height: 22px;
          display: flex;
          justify-content: space-between;
          margin: 10px;
          border-bottom: 1px solid #e1ebfa;
          padding: 6px 6px;
          h5 {
            border: none;
          }
          .label {
            color: #303a49;
            font-size: 14px;
            font-weight: 500;
            line-height: 22px;
          }
          .value {
            font-size: 16px;
            font-weight: 700;
          }
        }
        &:last-of-type {
          border-bottom: none;
        }
      }
      .attrs-label {
        padding: 8px 16px;
      }
    }
  }
`;
